var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { getHeader } from "../../resources/headers";
export var useGetCollectionReport = function () {
    var _a = useState(false), loadingCollectionReport = _a[0], setLoadingCollectionReport = _a[1];
    var _b = useState(false), responseCollectionReport = _b[0], setResponseCollectionReport = _b[1];
    var _c = useState(null), errorCollectionReport = _c[0], setErrorCollectionReport = _c[1];
    var getCollectionReport = function (collectionId) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, errBody, blob, objectUrl, link, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setLoadingCollectionReport(true);
                    setErrorCollectionReport(null);
                    setResponseCollectionReport(false);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, 7, 8]);
                    url = process.env.REACT_APP_HOST_API +
                        "/asg/Api/V1/Collections/".concat(collectionId, "/report");
                    return [4 /*yield*/, fetch(url, {
                            method: "GET",
                            headers: getHeader(),
                        })];
                case 2:
                    response = _a.sent();
                    if (!!response.ok) return [3 /*break*/, 4];
                    return [4 /*yield*/, response.json().catch(function () { return ({}); })];
                case 3:
                    errBody = _a.sent();
                    throw errBody;
                case 4: return [4 /*yield*/, response.blob()];
                case 5:
                    blob = _a.sent();
                    objectUrl = URL.createObjectURL(blob);
                    link = document.createElement("a");
                    link.href = objectUrl;
                    link.download = "Reporte de pagos y rechazos";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    URL.revokeObjectURL(objectUrl);
                    setResponseCollectionReport(true);
                    return [3 /*break*/, 8];
                case 6:
                    error_1 = _a.sent();
                    setErrorCollectionReport(error_1);
                    return [3 /*break*/, 8];
                case 7:
                    setLoadingCollectionReport(false);
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var clearCollectionReport = function () {
        setResponseCollectionReport(false);
        setErrorCollectionReport(null);
    };
    React.useEffect(function () {
        return function () {
            clearCollectionReport();
        };
    }, []);
    return {
        getCollectionReport: getCollectionReport,
        clearCollectionReport: clearCollectionReport,
        loadingCollectionReport: loadingCollectionReport,
        responseCollectionReport: responseCollectionReport,
        errorCollectionReport: errorCollectionReport,
    };
};
